import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLockOpen,
  faIdCard,
  faUsers,
  faPeopleGroup,
  faHeart,
  faProjectDiagram,
  faCogs,
  faMapMarkerAlt,
  faCalendarAlt,
  faListAlt,
  faUser,
  faKey,
  faCog,
  faTachometerAlt,
  faFileUpload,
  faImages,
  faStream,
  faTasks,
  faRobot,
  faArrowLeft,
  faList12,
  faAdd,
  faWallet
} from '@fortawesome/free-solid-svg-icons';

function SheEarnsProfileHome() {
   const authState = useSelector((state) => state.authReducer || {});
    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "User";
  
    const navigate = useNavigate();
    const dispatch = useDispatch();
  
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("Digital Income");
  
    const handleLogout = () => {
      dispatch(logout());
      navigate("/sheearns");
    };
  
  return (
      <div className="min-h-screen bg-black">
        <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
              {/* Header */}
              <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
                <div className="flex flex-col">
                  <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns</div>
                  <div className="text-[10px] lg:text-lg text-yellow-200">
                    SAKSHAM Shakti Profile
                  </div>
                </div>
        
                {/* Desktop user controls */}
                <div className="hidden md:flex items-center gap-3">
                  {isLoggedIn ? (
                    <>
                      <div className="text-xs text-left text-pink-300">{userName}</div>
                      <button
                        onClick={handleLogout}
                        className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                        title="Logout"
                      >
                        ⏻
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => navigate("/login")}
                        className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                      >
                        Login
                      </button>
                      <button
                        onClick={() => navigate("/signup")}
                        className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                      >
                        Register
                      </button>
                    </>
                  )}
                </div>
        
                {/* Mobile hamburger */}
                <button
                  onClick={() => setIsMobileMenuOpen((s) => !s)}
                  className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
                  aria-label="Toggle menu"
                >
                  {isMobileMenuOpen ? "×" : "☰"}
                </button>
              </header>
        
              {/* Mobile menu content */}
              {isMobileMenuOpen && (
                <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
                  {isLoggedIn ? (
                    <div className="flex flex-row items-center justify-center gap-3">
                      <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                        Welcome, {userName}
                      </span>
                      <button
                        onClick={handleLogout}
                        className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                        title="Logout"
                      >
                        ⏻
                      </button>
                    </div>
                  ) : (
                    <div className="flex flex-row items-center justify-center gap-6">
                      <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                        Login
                      </Link>
                      <span className="text-pink-500">|</span>
                      <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                        Register
                      </Link>
                    </div>
                  )}
                </div>
              )}
        <div className="mx-auto px-4 text-sm">
          <div className="flex justify-center mb-2 mt-2">
            <FontAwesomeIcon icon={faUser} className="text-3xl lg:text-4xl text-pink-500" />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2 border border-pink-500 py-2 px-2">
            <CardLink to="/myprofile-profile" icon={faUser} text="My Profile" />
            <CardLink to="/myprofile-think5whyscode" icon={faLockOpen} text="My Think5Whys Code" />
            <CardLink to="/contact-genious-home" icon={faIdCard} text="My Digital Card" />

            <CardLink to="/wallet-mywallet" icon={faWallet} text="My Think5Whys Purse / Wallet" />
            <CardLink to="/wallet-topup" icon={faAdd} text="Topup" />
            <CardLink to="/wallet-mywallettemp" icon={faList12} text="Pay by Other Method" />
            <CardLink to="/wallet-transfer" icon={faArrowLeft} text="Think5Whys Purse / Wallet Transfer" />
            <CardLink to="/wallet-pockettransfer" icon={faRobot} text="Transfer to ThinkAIInsight Pocket" />

            <CardLink to="/myprofile-ownteams" icon={faUsers} text="My Groups / Team" />
            <CardLink to="/myprofile-joinedteams" icon={faPeopleGroup} text="Groups / Team I have Joined" />
            <CardLink to="/myprofile-projects" icon={faTasks} text="My Projects" />
            <CardLink to="/myprofile-processes" icon={faStream} text="My Processes" />
            <CardLink to="/myprofile-locations" icon={faMapMarkerAlt} text="My Locations / Machines" />

            <CardLink to="/myprofile-intern" icon={faUser} text="My Think5Whys Internship Profile" />

            <CardLink to="/myprofile-changepassword" icon={faKey} text="Change Password" />
            <CardLink to="/myprofile-resetpassword-questions" icon={faKey} text="Reset Password Hint Questions" />
            <CardLink to="/myprofile-myorders" icon={faLockOpen} text="My Orders" />
            <CardLink to="/myprofile-myfiles" icon={faFileUpload} text="My File Uploader" />
          </div>
        </div>
      </div>
      <footer className="bg-[#2a0f2f] border-t border-pink-800 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm lg:text-lg text-yellow-200">
            © {new Date().getFullYear()} 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-[#005C5C]">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-[#005C5C]">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-[#005C5C]">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-[#005C5C]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-pink-300 p-2 rounded-lg shadow-lg">
    <Link to={to} className="flex items-center text-sm sm:text-m text-black hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-500 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default SheEarnsProfileHome;





              
